"use strict";
exports.getDaysInYear = getDaysInYear;
var _index = require("./isLeapYear.js");
var _index2 = require("./toDate.js");
function getDaysInYear(date) {
  const _date = (0, _index2.toDate)(date);
  if (String(new Date(_date)) === "Invalid Date") {
    return NaN;
  }
  return (0, _index.isLeapYear)(_date) ? 366 : 365;
}
